var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle4, _circle5, _path13, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSad = function SvgIconSad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 142"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 242.7,
    cy: 30.7,
    r: 5.8,
    fill: "#fff",
    stroke: "#bcc0c4",
    strokeWidth: 1.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.4,
    cy: 71.1,
    r: 70.5,
    fill: "#ebebeb"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.3,
    cy: 130.2,
    r: 5.8,
    fill: "#fff",
    stroke: "#ebebeb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M44.5 124.9h5v14.8h-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M39.5 129.9h15v4.9h-15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc0c4",
    d: "M20.2 82.6h6.4v19.1h-6.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc0c4",
    d: "M13.8 88.9H33v6.4H13.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M28.1 42.4h3.6V53h-3.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M24.5 45.9h10.7v3.5H24.5zM206.2 4.2h6.4v19.1h-6.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M199.8 10.6H219V17h-19.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc0c4",
    d: "M229 52.9h3.6v10.6H229z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc0c4",
    d: "M225.5 56.5h10.7V60h-10.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M221.9 91.1h5v14.8h-5z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M216.9 96h15v4.9h-15z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f4",
    d: "M93.8 40.9h64.9v81.3H93.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA291C",
    d: "M94.8 125.1h63.5V142H94.8zM95.2 27.5h62.7V38H95.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M154.4 144.8H98.8c-3 0-5.5-2.5-5.5-5.5V31.1c0-3 2.5-5.5 5.5-5.5h55.7c3 0 5.5 2.5 5.5 5.5v108.3c-.1 3-2.6 5.4-5.6 5.4zM93.5 39.9h66.4M93 123.5h66.4",
    strokeWidth: 5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.9,
    cy: 93.8,
    r: 2,
    fill: "#fcdede"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.3,
    cy: 93.8,
    r: 2,
    fill: "#fcdede"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.8 138.3c-1.8 0-3.3-1.5-3.3-3.3s1.5-3.3 3.3-3.3 3.3 1.5 3.3 3.3c0 1.9-1.5 3.3-3.3 3.3M131.9 98.8c1 0 1.7-.6 1.7-1.4 0-3.1-3.2-5.7-7-5.7s-7 2.5-7 5.7c0 .8.8 1.4 1.7 1.4zM140.4 87q1.95 0 3.3.9c0-.2.1-.4.1-.6 0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3c0 .2 0 .4.1.6.7-.5 1.9-.9 3.1-.9M112.8 87q1.95 0 3.3.9c0-.2.1-.4.1-.6 0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3c0 .2 0 .4.1.6.7-.5 1.9-.9 3.1-.9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.3,
    cy: 71.1,
    r: 75.9,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  })));
};
export default SvgIconSad;